import { SxProps, Theme } from "@mui/material";

export const cardContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  background: theme.palette.panelInfo.message.bg,
  p: 2,
  borderRadius: 1,
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.message.bgHover,
  },
});

export const cardFooterStyles: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const cardDateStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: "12px",
};

export const cardBadgeStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: "12px",
  px: 1,
  py: 0.5,
  borderRadius: 1,
};

export const markdownBoxStyles: SxProps<Theme> = {
  fontFamily: '"Red Hat Display", sans-serif',
};

export const tabLabelsStyles = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 0.5,
  mt: 1,
  "& > span": {
    fontSize: "11px",
    px: 1,
    py: 0.25,
    borderRadius: 1,
    backgroundColor: theme.palette.divider,
  },
});

export const imageStyles: SxProps<Theme> = {
  width: "100%",
  borderRadius: 2,
};

export const tagImageStyles: SxProps<Theme> = {
  maxWidth: "40%",
  borderRadius: 2,
};
